import React, {useEffect, useState} from 'react';
import Pagination from "../../common/pagination";
import ModalContainer from "../../common/modal_container";
import api from "../../../util/api";
import Btn from '../../layout/Btn';
import { SiteLogo2 } from '../../common/header';

export interface noticeListInterface {
    id: number,
    title: string,
    content: string,
    written_at: string,
}
export interface noticeApiInterface {
    total: number,
    notices: noticeListInterface[]
}
export function NoticeModal({popShow, setPopShow, openReadId, openDetail}:
                                {popShow: boolean; setPopShow: Function; openReadId: number; openDetail: noticeListInterface}){
    const [pages, setPages] = useState<number>(1)
    const [totalPages, setTotalPages] = useState<number>(0)

    const [readId, setReadId] = useState<number>(openReadId)
    const [noticeList, setNoticeList] = useState<noticeListInterface[]>()
    const [noticeDetail, setNoticeDetail] = useState<noticeListInterface>(openDetail)

    function getNoticeList(){
        api(`/api/site/notices/?page=${pages}`)
            .then(res=> res.json())
            .then((data: noticeApiInterface) => {
                setTotalPages(data.total)
                setNoticeList(data.notices)
            })
    }

    useEffect(()=> {
        if(openReadId){
            setReadId(openReadId)
            setNoticeDetail(openDetail)
        }
    }, [openReadId])
    useEffect(()=> {
        if(popShow){
            getNoticeList()
        }
    }, [pages, popShow])
    // useEffect(()=> {
    //     getNoticeList()
    // }, [])
    return (
        <ModalContainer show={popShow}
                        setShow={setPopShow}
                        className={'notice-popup'}
                        closeBtn
                        closeEvent={()=> {
                            setTimeout(()=> {
                                setReadId(0);
                                setPages(1);
                            }, 500)
                        }}
                        title={<><p>공지사항</p><SiteLogo2 /></>} >

            {
                readId ? <NoticeView viewIndex={readId} setViewId={setReadId} noticeDetail={noticeDetail}/> : <></>
            }
            <div className={"notice-table"}>
                <table>
                    <thead>
                    <tr>
                        <th>제목</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        noticeList?.map((item, index)=> (
                            <tr key={index}
                                className={ (item.id) == readId ? "select" : "" }>
                                <td onClick={e=> {
                                    setReadId(item.id)
                                    setNoticeDetail(item)
                                }}>
                                    <div className='list-row'>
                                        <span>●</span>
                                        <span>{item.title}</span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>

            <Pagination pages={pages}
                        setPages={setPages}
                        totalPages={totalPages} />
        </ModalContainer>
    )
}
NoticeModal.defaultProps = {
    openReadId: 0,
    openDetail: ""
}


function NoticeView({viewIndex, setViewId, noticeDetail}: {viewIndex: number, setViewId: Function, noticeDetail: noticeListInterface}){
    // console.log(noticeDetail.content)
    return (
        <div className={"notice-view"}>
            <header className="view-header">
                <p className={'title'}>{noticeDetail.title}</p>
                <div className={"view-info"}>
                    <div>
                        <span>관리자 <i className="rank-master"></i></span>
                        {/*|*/}
                        {/*<span>{moment(noticeDetail.written_at).format('YYYY-MM-DD HH:mm:ss')}</span>*/}
                    </div>
                    <div>
                        {/*<span>조회 0</span>*/}
                    </div>
                </div>
            </header>
            <main className={'view-main'} dangerouslySetInnerHTML={{__html:noticeDetail.content}}></main>
            <footer className={"btn-area"}>
                <Btn className='light-blue' onClick={e=> setViewId(0)}>목록</Btn>
            </footer>
        </div>
    )
}